<script setup lang="ts">
import type { Props } from './types';
import ControlLabel from '../controlLabel/controlLabel.vue';

defineProps<Props>();

const model = defineModel<Props['modelValue']>();
</script>

<template>
	<label
		:class="{
			['top-forms-optionWrapper']: true,
			['top-checkbox']: true,
			['top-checkbox_' + name]: !!name,
			['top-disabled']: disabled,
			['top-error']: isError && !disabled,
		}"
	>
		<input
			v-top-focus.onupdate="isError"
			type="checkbox"
			:class="{
				['top-forms-focusable']: !disabled,
				['top-forms-option']: true,
				['top-checkbox_input']: true,
				['top-error']: isError && !disabled,
			}"
			:name="name"
			v-model="model"
			:value="value"
			:indeterminate="indeterminate"
			:disabled="disabled"
		>

		<ControlLabel
			v-if="$slots.default"
			:description
			:disabled
		>
			<!-- @slot Слот с заголовком -->
			<slot></slot>
		</ControlLabel>
	</label>
</template>

<style>
.top-checkbox {
	cursor: pointer;
	display: inline-flex;
}

.top-checkbox_input {
	cursor: inherit;
	border-radius: 4px;
	background: var(--color-layout-front-1);
	border: 1px solid var(--top-forms-border-color);
	width: calc(var(--top-forms-option-height) - 3px * 2);
	height: calc(var(--top-forms-option-height) - 3px * 2);
}

.top-checkbox_input:before {
	content: " ";
	color: #FFF;
	font-family: "Topvisor-2";
	font-size: 16px;
	line-height: 1;
}

.top-checkbox_input:hover {
	border-color: var(--top-forms-border-color-hover);
	background: var(--color-layer-primary-1);
}

/* checked / indeterminate */
.top-checkbox_input:checked,
.top-checkbox_input:indeterminate {
	border-color: var(--top-forms-option-color);
	background: var(--top-forms-option-color);
}

.top-checkbox_input:checked:before {
	content: "";
}

.top-checkbox_input:indeterminate:before {
	content: "";
}

.top-checkbox_input:checked:hover,
.top-checkbox_input:indeterminate:hover {
	border-color: var(--top-forms-option-color-hover);
	background: var(--top-forms-option-color-hover);
}

/* isError */
.top-checkbox_input.top-error {
	border-color: var(--color-bg-negative-1);
}

.top-checkbox_input.top-error:hover {
	border-color: var(--color-bg-negative-2);
}

/* isError selected */
.top-checkbox_input:checked.top-error,
.top-checkbox_input:indeterminate.top-error {
	background: var(--color-bg-negative-1);
}

.top-checkbox_input:checked.top-error:hover,
.top-checkbox_input:indeterminate.top-error:hover {
	background: var(--color-bg-negative-2);
}
</style>
